import { render } from "./InstituteTrainningStatistics.vue?vue&type=template&id=ce159fb2&ts=true"
import script from "./InstituteTrainningStatistics.vue?vue&type=script&lang=ts"
export * from "./InstituteTrainningStatistics.vue?vue&type=script&lang=ts"

import "./InstituteTrainningStatistics.vue?vue&type=style&index=0&id=ce159fb2&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__